import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MbscModule, MbscPopup, MbscPopupOptions } from '@mobiscroll/angular';
import { ThemeService } from '../../../../services/shared/theme.service';
import { categoryData, eventFilterData, specialInfoData, typeData } from '../../../../interfaces/selectData';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SvgIconService } from '../../../../services/shared/icons/svg-icon.service';

@Component({
  selector: 'app-header-template',
  imports: [CommonModule, FormsModule, MbscModule,DragDropModule],
  templateUrl: './header-template.component.html',
  styleUrl: './header-template.component.scss'
})
export class HeaderTemplateComponent {
  @Input() openTeams: any;
  @Input() myData: any[] = [];
  @Input() stammteamData: any[] = [];
  @Input() zoomLevel: number = 2;

  @Output() openTeamsChange  = new EventEmitter<any>();
  @Output() zoomLevelChange = new EventEmitter<number>();
  @Output() eventFilterChange = new EventEmitter<any>();
  @Output() teamOrderChanged = new EventEmitter<string[]>();


  @ViewChild('teamOrderPopupAnchored', { static: false }) teamOrderPopupAnchored!: MbscPopup;
  teamOrderpopupAnchor: HTMLElement | undefined;
   anchoredOptions: MbscPopupOptions = {
    display: 'anchored',
  };
  teamOrderList: any[] = [];
  fixedTeamId: string | null = null;    
  pendingFixedTeamId: string | null = null;
  eventFilter = eventFilterData;
  selectedEventFilter: string[] = [];
  popupOptions: MbscPopupOptions = {
    display: 'anchored',
    touchUi: false,
    scrollLock: false,
    width: 320,
    maxHeight: '90%'
  };

  //LEGEND
  @ViewChild('legendPopupAnchored', { static: false }) legendPopupAnchored!: MbscPopup;
  legendpopupAnchor: HTMLElement | undefined;
   legendAnchoredOptions: MbscPopupOptions = {
    display: 'anchored',
    touchUi: false,
    scrollLock: false,
    width: '700px',
    maxHeight: '90%'
  };

  iconData = specialInfoData;
  typeData = typeData;
  categoryData = categoryData;

  constructor(public themeService: ThemeService, public svgIconService: SvgIconService) {}

  openLegendPopup(ev: any){
    this.legendpopupAnchor = ev.currentTarget;
    this.legendPopupAnchored.open();
  }

ngOnInit() {
  this.loadTeamOrder();
  this.fixedTeamId = localStorage.getItem('fixedTeam');
}

loadTeamOrder() {
  const savedOrder = JSON.parse(localStorage.getItem('teamOrder') || '[]');
  this.teamOrderList = savedOrder.map((id: string) => ({
    id,
    name: this.getTeamName(id)
  }));

  this.fixedTeamId = localStorage.getItem('fixedTeam');
}

isFixed(team: any): boolean {
  return team.id === this.pendingFixedTeamId;
}

  filterEvents(event: any){
    if(!event){return};
    const filterObjects = this.getFilterObjects(event);
    this.eventFilterChange.emit(filterObjects)
  }

  getFilterObjects(event:any){
    const filterObjects = event.map((filter: any)=>{
     return eventFilterData.find((obj: any)=> obj.value === filter);
    });
    return filterObjects;
  }

openAnchored(ev: any): void {
    this.loadTeamOrder();
    this.teamOrderpopupAnchor = ev.currentTarget;
    this.fixedTeamId = localStorage.getItem('fixedTeam');
    this.pendingFixedTeamId = this.fixedTeamId; 
    this.teamOrderPopupAnchored.open();
}

getTeamName(id: number | string): string {

  if (!this.stammteamData?.length) return String(id);

  const numericId = Number(id);

  const team = this.stammteamData.find(
    (t: any) => t.id === numericId
  );

  return team?.name ?? String(id);
}

getTeamColor(teamId: number | string): string {

  if (!this.stammteamData?.length) return '';

  const team = this.stammteamData.find(
    (t: any) => t.name === String(teamId)
  );

  return team?.color ?? '';
}

dropTeam(event: CdkDragDrop<any[]>) {
  moveItemInArray(this.teamOrderList, event.previousIndex, event.currentIndex);

  if (this.pendingFixedTeamId) {
    const fixedIndex = this.teamOrderList.findIndex(
      t => t.id === this.pendingFixedTeamId
    );

    if (fixedIndex > -1) {
      const fixedTeam = this.teamOrderList.splice(fixedIndex, 1)[0];
      this.teamOrderList.unshift(fixedTeam);
    }
  }

  this.teamOrderList = [...this.teamOrderList];
}


fixTeamFromPopup(team: any) {
  this.pendingFixedTeamId = team.id;

  this.teamOrderList = [
    team,
    ...this.teamOrderList.filter(t => t.id !== team.id)
  ];
}

unfixTeamFromPopup(team: any) {
  this.pendingFixedTeamId = null;
}

saveTeamOrder() {
  const orderIds = this.teamOrderList.map(t => t.id);

  localStorage.setItem('teamOrder', JSON.stringify(orderIds));

  if (this.pendingFixedTeamId) {
    localStorage.setItem('fixedTeam', this.pendingFixedTeamId);
  } else {
    localStorage.removeItem('fixedTeam');
  }

  this.teamOrderPopupAnchored.close();

  this.teamOrderChanged.emit(orderIds);
}

// ngOnInit() {
//   // debugger
//   this.teamSelectionService.selectedTeams$.subscribe(teams => {
//     this.updatingFromService = true;   // <— Markieren

//     this.selectedKey = [...teams];
//     this.selectedKeyChange.emit(this.selectedKey);

//     setTimeout(() => this.updatingFromService = false, 50);  // kurz danach zurücksetzen
//   });

//   const saved = JSON.parse(localStorage.getItem('selectedTeams') || '[]');

//   if (saved.length > 0) {
//     this.selectedKey = [...saved];
//     this.selectedKeyChange.emit(this.selectedKey);
//   }
// }

// showOnlyTeam(selected: string[]) {

//   // Wenn teamAll gewählt wurde → alles melden
//   if (selected.includes('teamAll')) {
//     this.openTeamsChange.emit(['teamAll']);
//     return;
//   }

//   // ansonsten normale Mehrfachauswahl melden
//   this.openTeamsChange.emit([...selected]);
// }



  handleZoom(newZoom: number) {
    if (newZoom >= 1 && newZoom <= 3) {
      this.zoomLevel = newZoom;
      this.zoomLevelChange.emit(this.zoomLevel);
    }
  }

  handleInput(event: any) {
    const value = Number(event.target.value);
    this.handleZoom(value);
  }

  getTeamClass(teamId: string) {
  switch (teamId) {
    case 'teamTuerkis': return 'bg-tuerkis';
    case 'teamBlau': return 'bg-blau';
    case 'teamGruen': return 'bg-gruen';
    case 'teamOrange': return 'bg-orange';
    case 'trainee': return 'bg-grey';
    case 'allgemein': return 'bg-grey';
    default: return 'bg-default';
  }
}
}
